export { default as SvgCheck } from './check'
export { default as SvgDateRange } from './date_range'
export { default as SvgEmptyHouse } from './empty-house'
export { default as SvgHistory } from './history'
export { default as SvgNotification } from './notifications'
export { default as SvgPeople } from './people'
export { default as SvgSearch } from './search'
export { default as SvgSend } from './send'
